import React, { useState } from 'react';

const AlertModal = ({ message, onClose, success }) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleClick = () => {
    setIsButtonDisabled(true); // Disable the button after clicking
    onClose(); // Close the modal or trigger the onClose action
  };

  const headerImage = success
    ? "/misc/SUCCESS.webp"
    : "/misc/FAILURE.webp";

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/80 z-50">
      <div className="flex flex-col items-center">
        {headerImage && (
          <img
            src={headerImage}
            alt=""
            className="w-96 mb-4 object-contain"
          />
        )}
        <div className="bg-gray-950/50 px-4 py-3 border border-pink-300/30 rounded-lg flex flex-col items-center">
          <h2 className="text-sm text-center">{message}</h2>
          <div className="mt-4">
            <button
              onClick={handleClick}
              className="px-6 py-2 bg-gray-500/50 text-white rounded-lg hover:bg-blue-950/90 transition-all duration-200 ease-in-out"
              disabled={isButtonDisabled} // Disable the button after click
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;